module.exports = __webpack_public_path__ + "img/0108.3553ffec.png";